//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { pageDefs } from '@/libs/router';

export default {
    constants: {
        $,
        pageDefs,
    },
    computed: {
        topNavShown() {
            return this.$route.name && !['login', 'podpis', 'notFound'].includes(this.$route.name);
        },
        leftNavShown() {
            return this.isRouteUnder('vozidla', 'nastaveni', 'mujUcet');
        },
    },

    methods: {
        isRouteUnder(...paths) {
            return paths.some(path => new RegExp(`/app/${path}(/|$)`).test(this.$route.path));
        },
    },

    async created() {
        const authToken = localStorage.getItem('authToken');

        if (authToken) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${authToken}`;

            $.loggedIn = true;
            $.currentUser = await $.fetchOne('users', 'self');
        }
    },

    meta() {
        return {
            titleTemplate: title => `${title} | SR3`,
            title: this.$route.name && this.$t(`pages.${this.$route.name}`),
        };
    },
};
